// ** Modules
import { useQuery } from '@apollo/client/react';
import { gql, type TypedDocumentNode } from '@apollo/client';

// ** Utils
import { MediaFields } from './fragments';

// ** Types
import type { Query } from '@/types/graphql';

// ** Queries Schemas
export const getCarouselMediaItems: TypedDocumentNode<Pick<Query, 'carouselMediaItems'>> = gql`
    ${MediaFields}
    query MediaCarouselItems(
        $locale: I18NLocaleCode
        $status: PublicationStatus = PUBLISHED
        $fetchNews: Boolean!
        $fetchPodcasts: Boolean!
        $fetchFiles: Boolean!
        $fetchEvents: Boolean!
        $fileFilters: DataFileFiltersInput = { fileCategory: { eq: "Perspektive" } }
    ) {
        carouselMediaItems(
            locale: $locale
            status: $status
            fetchNews: $fetchNews
            fetchPodcasts: $fetchPodcasts
            fetchFiles: $fetchFiles
            fetchEvents: $fetchEvents
            fileFilters: $fileFilters
        ) {
            data {
                documentId
                title
                description
                imageUrl
                carouselHost
                ctaLabel
                publishedAt
                slug
                typeLabel
                type
                imageData {
                    ...MediaFields
                }
            }
        }
    }
`;

//////////////////
// ** Query Functions

// Get Carousel Media Items
export const useGetCarouselMediaItems = (locale: string, mediaTypes: string[] = []) => {
	const fetchNews = !!mediaTypes?.includes('News');
	const fetchPodcasts = !!mediaTypes?.includes('Podcast');
	const fetchFiles = !!mediaTypes?.includes('Perspektiven');
	const fetchEvents = !!mediaTypes?.includes('Event');

	const { data, loading, error, refetch } = useQuery(getCarouselMediaItems, {
		variables: {
			locale,
			status: 'PUBLISHED',
			sort: ['publishedAt:desc'],
			fetchNews,
			fetchPodcasts,
			fetchFiles,
			fetchEvents
		},
		skip: !locale,
		fetchPolicy: 'cache-and-network'
	});

	return {
		carouselMediaItems: data?.carouselMediaItems?.data ?? [],
		loading,
		error,
		refetch
	};
};
